import { STORAGE_KEYS } from 'constants/enums';
import { addLogsToSentry } from 'helpers/sentry';

const storeUserIdFromTransactionId = (transactionId: string) => {
  const [userId] = transactionId.split('_').slice(-1);

  if (userId !== null && userId !== '') {
    try {
      localStorage.setItem(STORAGE_KEYS.USER_ID_POST_2FA_RESET, userId);
    } catch (error) {
      addLogsToSentry({}, error);
    }
  }
};

export { storeUserIdFromTransactionId };
